import classNames from 'classnames';
import s from './IdentificationStatusEmpty.module.scss';

export default function IdentificationStatusEmpty() {
  return (
    <>
      <div className={s.status} data-test="IdentificationStatusEmpty">
        <div className={classNames([s.loadingShimmer, s.icon])} />
        <div
          className={s.content}
          data-test="IdentificationStatusEmpty-content"
        >
          <div
            className={classNames([s.loadingShimmer, s.title])}
            data-test="IdentificationStatusEmpty-content-title"
          />
          <div
            className={classNames([s.loadingShimmer, s.text])}
            data-test="IdentificationStatusEmpty-content-text-1"
          />
          <div
            className={classNames([s.loadingShimmer, s.text])}
            data-test="IdentificationStatusEmpty-content-text-2"
          />
          <div
            className={classNames([s.loadingShimmer, s.text])}
            data-test="IdentificationStatusEmpty-content-text-3"
          />
        </div>
      </div>
      <div className={classNames([s.button, s.loadingShimmer])} />
    </>
  );
}
